import { render, staticRenderFns } from "./NotariusAction.vue?vue&type=template&id=7e8e9c7e&scoped=true&"
import script from "./NotariusAction.vue?vue&type=script&lang=js&"
export * from "./NotariusAction.vue?vue&type=script&lang=js&"
import style0 from "./NotariusAction.vue?vue&type=style&index=0&id=7e8e9c7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8e9c7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
